import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60a10fac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile-view container d-flex justify-content-center py-4 py-md-5" }
const _hoisted_2 = { class: "col-12 col-lg-11 col-xl-10" }
const _hoisted_3 = { class: "form" }

import { useHead } from "@unhead/vue";
import PageHero from "@/components/misc/PageHero.vue";
import ProfileForm from "@/components/forms/ProfileForm.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileView',
  setup(__props) {

useHead({
  title: "My Profile",
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(PageHero, {
        title: "My Profile",
        subtitle: "Your details, and how we reach you."
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(ProfileForm)
      ])
    ])
  ]))
}
}

})